import React from 'react'
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
const NotificationHandler = () => {
  return (
    <ToastContainer />
  )
}

export default NotificationHandler;
